var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1306 3.05312V1.18171C13.1306 0.13419 14.4198 -0.395455 15.1718 0.346048L20.6508 5.74843C21.1164 6.20745 21.1164 6.94896 20.6508 7.40798L15.1718 12.8104C14.4198 13.5519 13.1306 13.034 13.1306 11.9865V9.99736C7.16214 9.99736 2.98423 11.8805 0 16C1.19369 10.1151 4.77476 4.23011 13.1306 3.05312Z",
    fill: "#FF8B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.49d9293c6ee971b7c363778a5890e499.svg";
export { ForwardRef as ReactComponent };